var menuSearchBar = document.getElementById('dgwt-wcas-search-input-1');

function eventFire(el, etype) {
    if (el.fireEvent) {
        el.fireEvent('on' + etype);
    } else {
        var evObj = document.createEvent('Events');
        evObj.initEvent(etype, true, false);
        el.dispatchEvent(evObj);
    }
}
eventFire(menuSearchBar, 'click');